﻿import Swiper from 'swiper';
import { Pagination, Navigation, Controller, EffectFade } from 'swiper/modules';
Swiper.use([Pagination, Navigation, Controller, EffectFade]);
import { debounce } from '../functions.js';

document.addEventListener('DOMContentLoaded', () => {
    const $logoSliders = document.querySelectorAll('.widget-logo-slider');

    $logoSliders.forEach($logoSlider => {
        let $next = $logoSlider.querySelector('.swiper-button-next');
        let $prev = $logoSlider.querySelector('.swiper-button-prev');
        let $pagination = $logoSlider.querySelector('.swiper-pagination');

        new Swiper($logoSlider, {
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            spaceBetween: 40,
            slidesOffsetAfter: -40,
            breakpoints: {
                480: {
                    spaceBetween: 60,
                    slidesOffsetAfter: -60
                },
                768: {
                    spaceBetween: 90,
                    slidesOffsetAfter: -90
                },
                1023: {
                    spaceBetween: 120,
                    slidesOffsetAfter: -120
                }
            },
            navigation: {
                nextEl: $next,
                prevEl: $prev
            },
            pagination: {
                el: $pagination,
                type: 'progressbar'
            },
        });

    });

    const $mixedMediaSliders = document.querySelectorAll('.widget-slider');

    $mixedMediaSliders.forEach($mixedMediaSlider => {
        let $slider = $mixedMediaSlider.querySelector('.swiper');
        let $next = $mixedMediaSlider.querySelector('.swiper-button-next');
        let $prev = $mixedMediaSlider.querySelector('.swiper-button-prev');
        let $pagination = $mixedMediaSlider.querySelector('.swiper-pagination');
        new Swiper($slider, {
            slidesPerView: 1.2,
            spaceBetween: 24,
            watchSlidesProgress: true,
            breakpoints: {
                1024: {
                    spaceBetween: 32,
                    slidesPerView: 2.15
                }
            },
            pagination: {
                el: $pagination,
                type: 'progressbar'
            },
            navigation: {
                nextEl: $next,
                prevEl: $prev
            }
        });
    });

    const $reviewSliders = document.querySelectorAll('.widget-reviews');

    if ($reviewSliders) {
        const swiperInstances = [];

        var quoteSettings = {
            slidesPerView: 1.2,
            spaceBetween: 24,
            slidesPerGroup: 1,
            speed: 1000,
            fadeEffect: { crossFade: true },
            breakpoints: {
                768: {
                    spaceBetween: 0,
                    slidesPerView: 1
                }
            },
            preventInteractionOnTransition: true
        }

        var breakpoint = 769;
        var isMobile = window.innerWidth <= breakpoint;
        var state = isMobile ? 'mobile' : 'desktop';

        $reviewSliders.forEach($reviewSlider => {
            let $quoteSlider = $reviewSlider.querySelector('.swiper-quote');
            let $imageSlider = $reviewSlider.querySelector('.swiper-images');
            let $next = $reviewSlider.querySelector('.swiper-button-next');
            let $prev = $reviewSlider.querySelector('.swiper-button-prev');
            let $pagination = $reviewSlider.querySelector('.swiper-pagination');
            let imageSwiper = null;

            if ($imageSlider) {
                imageSwiper = new Swiper($imageSlider, {
                    slidesPerView: 1.2,
                    spaceBetween: 24,
                    slidesPerGroup: 1,
                    speed: 1000,
                    breakpoints: {
                        breakpoint: {
                            spaceBetween: 0,
                            slidesPerView: 1.3
                        }
                    },
                    preventInteractionOnTransition: true
                });
            }

            quoteSettings.effect = isMobile ? 'slide' : 'fade';
            quoteSettings.pagination = {
                el: $pagination,
                type: 'progressbar'
            };
            quoteSettings.navigation = {
                nextEl: $next,
                prevEl: $prev
            };

            let quoteSwiper = new Swiper($quoteSlider, quoteSettings);
            let swps = { 'qs': quoteSwiper, 'is': imageSwiper };
            swiperInstances.push(swps);

            if ($imageSlider) {
                imageSwiper.controller.control = quoteSwiper;
                quoteSwiper.controller.control = imageSwiper;
            }

        });

        window.addEventListener('resize', debounce(() => {
            isMobile = window.innerWidth <= breakpoint;
            var newState = isMobile ? 'mobile' : 'desktop';
            if (state !== newState) {
                state = newState;
                quoteSettings.effect = isMobile ? 'slide' : 'fade';
                swiperInstances.forEach(swiper => {
                    let $el = swiper.qs.el;
                    let $next = $el.parentNode.parentNode.querySelector('.swiper-button-next');
                    let $prev = $el.parentNode.parentNode.querySelector('.swiper-button-prev');
                    let $pagination = $el.parentNode.parentNode.querySelector('.swiper-pagination');
                    quoteSettings.effect = isMobile ? 'slide' : 'fade';
                    quoteSettings.pagination = {
                        el: $pagination,
                        type: 'progressbar'
                    };
                    quoteSettings.navigation = {
                        nextEl: $next,
                        prevEl: $prev
                    };
                    swiper.qs.destroy();
                    swiper.qs = new Swiper($el, quoteSettings);
                    if (swiper.is) {
                        swiper.is.controller.control = swiper.qs;
                        swiper.qs.controller.control = swiper.is;
                    }
                });
            }
        }));
    }
});
